import { Box, Stack } from '@mantine/core';
import type { CheckStateResponse } from '@repo/common/interfaces';
import { observer } from 'mobx-react-lite';
import { useCallback, useEffect, useState } from 'react';
import { checkChromeExtensionState } from '../../../utils/extension';
import { ChromeExtensionRow } from './ChromeExtensionRow';

type ChromeExtensionState = {
	main?: CheckStateResponse;
	beta?: CheckStateResponse;
};

export const ChromeExtensionSettings = observer(() => {
	const [chromeExtensionState, setChromeExtensionState] =
		useState<ChromeExtensionState>({
			main: undefined,
			beta: undefined,
		});

	const getChromeExtensionState = useCallback(async () => {
		const { main } = await checkChromeExtensionState();
		setChromeExtensionState({ main });
	}, []);

	useEffect(() => {
		getChromeExtensionState();
	}, [getChromeExtensionState]);

	const updateAuthenticatedState = useCallback(() => {
		getChromeExtensionState();
	}, [getChromeExtensionState]);

	return (
		<Stack>
			<Box>
				<ChromeExtensionRow
					installed={chromeExtensionState.main?.installed ?? false}
					authenticated={chromeExtensionState.main?.authenticated ?? false}
					version={chromeExtensionState.main?.version}
					onAuthenticatedChange={updateAuthenticatedState}
				/>
			</Box>
		</Stack>
	);
});
